import { useParams } from 'react-router-dom';

import { snapStore } from 'containers/Snaps/Snap/store';
import { CRUDTable } from 'components';

import {
  useDeleteRequest,
  useGetRequest,
  useMemoState,
} from 'hooks';

import { OfferLineItemMatch, SnapMatchesResponse } from 'codegen';

import {
  columns,
  handleDeleteMatchesLineItem,
  handleSuccessDeleteMatchesLineItem,
  handleSuccessGetMatchesLineItems,
  initialTableActions,
} from './lib';

export const OfferMatches = () => {
  const lineItemOptions = snapStore((state) => state.lineItemOptions);
  const eligibleOfferOptions = snapStore((state) => state.eligibleProductOptions);

  const { snapId } = useParams();

  const [matchesData, setMatchesData] = useMemoState<OfferLineItemMatch[]>([]);

  const { loading } = useGetRequest<SnapMatchesResponse>({
    url: `/snaps/old/${snapId}/matches/v2`,
    options: {
      onSuccess: handleSuccessGetMatchesLineItems(setMatchesData),
      refreshDeps: [snapId],
    },
  });

  const [deleteMatchesItem, { loading: deleteLoading }] = useDeleteRequest({
    options: {
      onSuccess: handleSuccessDeleteMatchesLineItem(setMatchesData),
    },
  });

  return (
    <CRUDTable
      id='offer-matches'
      title='Offer Matches'
      loading={loading || deleteLoading}
      dataSource={matchesData}
      columns={columns(lineItemOptions, eligibleOfferOptions)}
      initialTableActions={initialTableActions}
      onDeleteTableData={handleDeleteMatchesLineItem(deleteMatchesItem, snapId)}
    />
  );
};
